export default __webpack_public_path__ + "static/media/Miracle.de0f91a7.png";